module.exports = __webpack_public_path__ + "img/hub-approve.29ee63cd.svg";